<template lang="pug">
  .cart-item
    .item-left.xs-10.lg-11.text-left
      .prod-thumb-wrap
        a(v-if="item.url_key && item.hasContent" :href="productUrl" target="_self")
          img.prod-thumb(:src="imgSrc" :alt="altText")
        img.prod-thumb(v-if="!item.url_key || !item.hasContent" :src="imgSrc" :alt="altText")

      .prod-info.xs-12.lg-7
        .xs-12
          template(v-if="item.url_key && item.hasContent && !item.isExtraTube")
            a.prod-type.block.xs-f-small.max-at-tweak.upper.semi-bold.color-black(:href="productUrl" target="_self") {{ item.productType }}
            a.prod-name.block.xs-f-xsmall.max-at-tweak.color-slate(:href="productUrl" target="_self" data-mr-ass="cart-product-name") {{ item.name }}
            p.prod-desc.xs-f-xsmall.max-at-tweak.color-slate(data-mr-ass='cart-product-desc') {{ item.desc.short }}

          template(v-else)
            p.prod-type.xs-f-small.max-at-tweak.upper.semi-bold.color-black(v-if="!item.url_key || !item.hasContent") {{ item.productType }}
            p.prod-name.xs-f-xsmall.max-at-tweak.color-slate(data-mr-ass='cart-product-name') {{ item.name }}
            p.prod-desc.xs-f-xsmall.max-at-tweak.color-slate(v-if='item.isExtraTube' data-mr-ass='cart-tube-desc') {{ item.extraTubeCartDescription }}
            p.prod-desc.xs-f-xsmall.max-at-tweak.color-slate(v-if='!item.isExtraTube' data-mr-ass='cart-product-desc') {{ item.desc.short }}

        .auto-delivery.xs-12
          SubFrequencyTag(v-if='showSubFrequencyTag' :frequency="item.subscription" data-mr-ass="delivered-text").xs-mr-50m
          //- this on is for attachables
          label(v-if="showAttachableFrequency")
            SubFrequencyTag(:frequency="item.attachableFrequency")
              mr-input-checkbox.sub-checkbox.inline-block(v-model="localAttachableFrequency" @input="updateAttachableFrequency")

          .delivered-wrap(v-if="editing && canBeSubscribed && isItemEditable")
            p.xs-f-xsmall.max-at-tweak Delivered:
            dropdown(label="Ships Every" v-model="subFrequency" data-mr-ass="sub-frequency")
              option(v-for="freq in subFrequencyOptions" :value="freq.val" :key="freq.val") {{ freq.label }}

          div(v-if="showSimpleEdit" :class="{'inline-block': showSubFrequencyTag }")
            button.transparent-btn.xs-f-xsmall.max-at-tweak.color-mr-purple(@click='editProduct' type="button" data-mr-ass="cart-edit") Edit

          button.transparent-btn.xs-f-small.max-at-tweak.color-mr-purple(v-if="canBeConvertedToAutoDelivery && !editing" @click='editProduct' type="button" data-mr-ass="save-with-auto-delivery")
            span.icon-pos-circle.xs-f-xmedium.max-at-tweak
            | &nbsp;Add Auto Delivery

          button.transparent-btn.xs-f-small.max-at-tweak.color-mr-purple(v-if="canAddToNextDelivery" @click="moveToRefillCart" type="button")
            span.icon-pos-circle.xs-f-xmedium.max-at-tweak
            | &nbsp;Add to next delivery

      .qty-edit.xs-12.lg-5
        .inline-block
          span.xs-f-xsmall.max-at-tweak.upper.xs-pr-50m qty:
          template(v-if='canEditQty')
            QtyButtons(:qty="item.qty" @qtyChange="updateProdQty" data-mr-ass="cart-quantity-buttons")
          template(v-else)
            span {{ item.qty }}

    .item-right.xs-2.lg-1.text-right
      p.xs-f-small.max-at-tweak.semi-bold(v-if="item.index != null"  data-mr-ass="cart-price") {{ itemTotalPrice | freeCurrency }}
      p.xs-f-small.max-at-tweak.semi-bold.strike(v-if="item.index == null && (freeItemsMap[item.code] && freeItemsMap[item.code].showOriginalPrice)" data-mr-ass="cart-price") {{ itemTotalPrice | freeCurrency }}
      p.xs-f-small.max-at-tweak.semi-bold(v-if="item.index == null && freeItemsMap[item.code]" data-mr-ass="cart-price") {{ 0 | freeCurrency }}
      button.transparent-btn.xs-f-xsmall.max-at-tweak.color-mr-purple(v-if="item.index != null" @click="removeItemFromCart" data-mr-ass="cart-remove-item") Remove

</template>

<script>
  import { currency } from "../../../filters";
  import { mapState, mapActions, mapGetters } from "vuex";

  export default {
    name: "CartItem",
    components: {
      MrInputCheckbox: () => import("../../mrInputCheckbox"),
      SubFrequencyTag: () => import("../SubFrequencyTag/SubFrequencyTag"),
      QtyButtons: () => import("../../QtyButtons")
    },

    inject: ['getObjProperty'],

    data() {
      return {
        localEditing: false,
        localAttachableFrequency: false
      }
    },

    props: {
      item: {
        type: Object,
        required: true
      }
    },

    watch: {
      'item.subscription': { //- this will keep attachable checkbox up to date when the state gets updated
        immediate: true,
        handler(val) {
          this.localAttachableFrequency = val;
        }
      }
    },

    computed: {
      ...mapState('cart', ['editAllItems']),
      ...mapState('refillCart', ['refillCart']),
      ...mapState('subscriptions', ['defaultFrequencies']),
      ...mapState('customer', ['cdata']),
      ...mapGetters('cart', ['freeItemsMap']),
      ...mapGetters('customer', ['hasMembershipPricing']),

      altText() {
        return `Madison Reed - ${this.item.name}`;
      },

      imgSrc() {
        return this.getObjProperty(this.item, 'imagery.thumb.url');
      },

      editing() {
        return this.localEditing || this.editAllItems;
      },

      productUrl() {
        return `/product/${this.item.url_key}`
      },

      itemTotalPrice() {
        return this.item.qty * this.item.price;
      },

      isItemEditable() {
        return Boolean(this.canBeSubscribed && !(isNaN(+this.item.index) || this.item.isExtraTube || this.item.isBundle));
      },

      canBeConvertedToAutoDelivery() {
        return Boolean(this.item.subscription == 0 && this.canBeSubscribed && !this.refillCart.nextShipment);
      },

      canAddToNextDelivery() {
        return Boolean(this.item.subscription == 0 && this.item.inventory_status != 'discontinued' && this.refillCart.nextShipment && !this.item.giftCard);
      },

      canBeSubscribed() {
        return Boolean(this.item.product_type_sub_frequencies && this.item.product_type_sub_frequencies != '' && this.item.inventory_status != 'discontinued');
      },

      canEditQty() {
        return Boolean(!isNaN(+this.item.index) && !this.item.isExtraTube && !this.item.giftCard);
      },

      showSubFrequencyTag() {
        return Boolean(this.item.subscription && (!this.editing || (this.editing && !this.isItemEditable)) && !this.showAttachableFrequency);
      },

      showSimpleEdit() {
        return this.isItemEditable && !this.editing && this.showSubFrequencyTag;
      },

      showAttachableFrequency() {
        return Boolean(this.item.attachableFrequency && !this.item.isExtraTube && (this.item.subscription == 0 || this.item.subscription == this.item.attachableFrequency ));
      },

      subFrequency: {
        get() {
          return this.item.subscription;
        },

        set(subscription) {
          let payload = {
            index: this.item.index,
            subscription
          };

          if (this.canBeConvertedToAutoDelivery && this.editAllItems) {
            payload.ctaSource = this.hasMembershipPricing? 'membershipBanner' : 'subscribeToSave';
          }

          this.updateItemSubscription(payload).then(() => {
            this.localEditing = false;
          });
        }
      },

      subFrequencyOptions() {
        let frequencies = this.item.product_type_sub_frequencies || this.defaultFrequencies;
        frequencies = frequencies.split(',').map(Number);
        //- add 0 for One Time option
        frequencies.unshift(0);

        return frequencies.map(frequency => {
          let label;

          if (frequency == 0) {
            label = `One time - ${currency(this.item[this.item.oneTimePriceKey])}`;
          } else {
            label = `Every ${frequency} weeks - ${currency(this.item[this.item.subPriceKey])}`;
          }

          return { val: frequency, label };
        });
      }
    },

    methods: {
      ...mapActions('cart', [
        'updateItemQty',
        'updateItemSubscription',
        'moveToOtherCart',
        'removeFromCart'
      ]),

      editProduct() {
        this.localEditing = true;
      },

      updateAttachableFrequency(val) {
        let subscription = val ? this.item.attachableFrequency : 0;
        let payload = {
          index: this.item.index,
          subscription
        };

        this.updateItemSubscription(payload);
      },

      updateProdQty(qty) {
        let payload = {
          index: this.item.index,
          qty,
          ctaSource: 'cart-edit-qty'
        };

        this.updateItemQty(payload);
      },

      removeItemFromCart() {
        this.removeFromCart({ index: this.item.index });
        this.removeXSellToConvertItem();
      },

      moveToRefillCart() {
        let params = {
          from: 'cart',
          to: 'refill',
          index: this.item.index
        };

        this.moveToOtherCart(params);
      },

      removeXSellToConvertItem() {
        let xsellKeys = ['position', 'impression', 'product', 'category', 'sku', 'productId'];
        let xSellCookie = this.$cookies.get('xSellConverted');
        if (xSellCookie) {
          let xSellConverted = JSON.parse(xSellCookie);
          for (var i = 0; i < xSellConverted.length; i++) {
            let row = xSellConverted[i];
            if (row[xsellKeys.indexOf('productId')] == this.item.id) {
              xSellConverted.splice(i, 1);
            }
          }

          this.$cookies.set('xSellConverted', JSON.stringify(xSellConverted));
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .cart-item
    padding 1.5em 0
    border-bottom 1px solid #ebebeb

    &:first-child
      border-top 1px solid #ebebeb

    .item-left
      position relative
      padding-left 4em
      padding-right 0.5em

      .prod-thumb-wrap
        position absolute
        top 0
        left 0

        .prod-thumb
          width 3.2em

      .prod-info
        padding-right 0.5em

      .icon-pos-circle
        &:before
          margin 0

      .auto-delivery
        margin-bottom 0.5em

      .qty-edit
        .edit-save
          line-height 40px

  @media mq-mobile
    .cart-item
      padding 1.5em 0.2em

  @media mq-desktop-md-plus
    .cart-item
      .item-left
        padding-left 5.75em

        .prod-thumb-wrap
          .prod-thumb
            width 4.75em

</style>

<style lang="stylus">
  .cart-item
    .sub-checkbox
      .mr-checkbox
        width 16px
        height 16px

        &.selected:before
          font-size 13px
          line-height 15px
          width 15px
          height 15px

</style>